import React from 'react';
import Layout from '../style/Layout.js'
import TestimonialSlider from '../components/TestimonialSlider';

const MillerWritingCenter = () => {
   return (
      <Layout>
         <main>
            <h1>Miller Writing Center</h1>

            <h2>Summary</h2>

            <p> I’ve worked as a peer writing consultant at the Miller Writing Center since January 2022 
               (with a brief stint spent away for an internship). I was a sophomore at that point in time. 
               I can honestly say that I have thoroughly enjoyed my time as a consultant. It has taught me many things about life, 
               people, communication, and, of course, writing! This page is dedicated to my experience as a consultant; 
               I’ll share my consulting philosophy, some artifacts, and other related information.
            </p>

            <h2>
               Consulting Philosophy
            </h2>

            <p>
            To many students graduate without having developed the crucial life skill of writing. Clear writing reflects is close to clear thinking. Good writing is valuable in the work place. Every professional must express their ideas efficiently and effectively.
            </p>

            <p>Here are my primary consulting values.</p>

            <ol className='styled-numbered bolded-markers'>
               <li className='list-item-bordered'>
                  <strong>Client Agency</strong>
                  <p className='ml-4'>
                     I believe that clients should be empowered to take control of their writing process and make decisions about their own work.
                  </p>
               </li>
               
               <li className='list-item-bordered'>
                  <strong>Precision</strong>
                  <p className='ml-4'>
                     I value attention to detail and accuracy, and I encourage clients to refine their writing to achieve the highest level of clarity, conciseness, and coherence. Reading passages aloud is useful for this.
                  </p>
               </li>

               <li className='list-item-bordered'>
                  <strong>Challenge</strong>
                  <p className='ml-4'>
                     I challenge clients to push beyond their comfort zones to get better and reap the rewards of their hard work.
                  </p>
               </li>

               <li className='list-item-bordered'>
                  <strong>Encouragement</strong>
                  <p className='ml-4'>
                     Writing is close to home. It's important to pair feedback and constructive criticsm with encouragement about what the client is doing well.
                  </p>
               </li>

               <li className='list-item-bordered'>
                  <strong>Adaptation</strong>
                  <p className='ml-4'>
                  Each client and brings different experience and knowledge levels to the table. I think it's important to meet each client where they're at.
                  </p>
               </li>
            </ol>

            <h2>Testimonials</h2>

            <TestimonialSlider/>

         </main>
      </Layout>
   );
};

export default MillerWritingCenter;
